/**********************************************************
Tree Replant Form
**********************************************************/
import { TextInput, NumberInput, DatePicker,
    RadioButton, SelectField, AutoComplete, Select } from '../inputs'; 
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { findEmployeeByName } from '../../../utils';
import { mapEmployeeForAutoComplete } from '../../cult_utils';  
import EmployeeList from '../../../components/employee_list';
const propTypes = {
  fields: PropTypes.array,
  fetchFields: PropTypes.func
};

class TreeReplantForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inventoryTransactionId: ``
    }
  }
  render() {
    return (
      <div>
        <form id={this.props.formId} onSubmit={(e) => e.preventDefault()}>
          { this.props.editing ? 
            <span><h3 className="blue-text">Edit Replant Log</h3>< hr /></span>
          : `` }
          <div className="row">
            <div className="col s12 m3 l3 xl3">
              <DatePicker id={`treeReplant${this.props.inputId}-date`} label={`Date`} min={`2019-01-01`} max={moment().format(`YYYY-MM-DD`)} required={true} />
            </div>
            <div className="col s12 m3 l3 xl3">
              <label>Location</label>
              <div className="radio-flex">
                  <RadioButton id={`treeReplant${this.props.inputId}-kau`} name={`treeReplant-location`} value={`71`} label={`Kau`} onClick={(e) => this.props.fetchFields(e.target.value)} />
                  <RadioButton id={`treeReplant${this.props.inputId}-keaau`} name={`treeReplant-location`} value={`72`} label={`Keaau`} onClick={(e) => this.props.fetchFields(e.target.value)} />
              </div>
            </div>
            <div className="col s12 m3 l3 xl3">
                <SelectField id={`treeReplant${this.props.inputId}-field`} label={`Field`} opts={this.props.fields} />
            </div>
            <div className="col s12 m3 l3 xl3">
              { this.props.editing ?
                <Select id={`treeReplant${this.props.inputId}-inventoryTransactionId`} label={`Inventory Transaction`} disabled={'disabled'}
                opts={this.props.inventoryTransactions.filter((i) => i.isApproved === 1 && i.issuedOrReceived === `I`)
                                                      .map((i) => { return { val: i.id, label: `${moment(i.date).format(`MM/DD/YYYY`)}, ${i.field}, ${i.quantity} trees` } })}   
                /> :
                <Select id={`treeReplant${this.props.inputId}-inventoryTransactionId`} label={`Inventory Transaction`}
                opts={this.props.inventoryTransactions.filter((i) => i.isApproved === 1 && i.issuedOrReceived === `I`)
                                                      .map((i) => { return { val: i.id, label: `${moment(i.date).format(`MM/DD/YYYY`)}, ${i.field}, ${i.quantity} trees` } })}   
                />
              }
              
            </div>
          </div>
          <div className="row">
            <div className="col s12 m3 l3 xl3">
              <NumberInput id={`treeReplant${this.props.inputId}-hours`} label={`Hours`} step={"1.0"} min={"0"} />
            </div>
            <div className="col s12 m3 l3 xl3">
              <NumberInput id={`treeReplant${this.props.inputId}-treesPlanted`} label={`Trees Planted`} step={"1.0"} min={"0"} />
            </div>
            <div className="col s12 m6 l6 xl6">
              <TextInput id={`treeReplant${this.props.inputId}-comments`} label={`Comments`} defaultValue={`N/A`} />
            </div>
          </div>
        </form>
        <div className="row">
          {
            this.props.editing ?
              <div className="col s12 m2 l2 xl2">
                <AutoComplete id={`treeReplant${this.props.inputId}-employee`} label={'Employee'}
                  data={mapEmployeeForAutoComplete(this.props.employees)} 
                  onComplete={(val, id) => this.props.addEmployee(findEmployeeByName(val, this.props.employees), id)} />
                <div className="emp-list-replant hide-on-small-only">
                  <div className="card">
                    <EmployeeList employees={this.props.employees} icon={'person_add'} header={'Add Employees'} onClick={this.props.addEmployee} _class={'green'} />
                  </div>
                </div>
              </div>
            : ''
          }
          <div className="col s12 m10 l10 xl10">
          {
            this.props.addedEmployees.length > 0 ?
              <table className="centered bordered responsive-table">
                <thead>
                  <tr>
                    <th>Employee</th>
                    <th>Remove</th>
                  </tr>
                </thead>
                <tbody>
                {
                  this.props.addedEmployees.map((e) => (
                    <tr key={e.eid}>
                      <td>{ e.name }, { e.position }</td>
                      <td>
                        <button onClick={() => this.props.removeEmployee(e)} className="btn-floating waves-effect waves-light red table-btn">
                          <i className="material-icons">clear</i>
                        </button>
                      </td>
                    </tr>
                  ))
                }    
                </tbody>
              </table>
            : ``
          }
          </div>
        </div>
      </div>
    );
  }
}

TreeReplantForm.propTypes = propTypes;
export default TreeReplantForm;
  
  
  
  /* END */
  


// WEBPACK FOOTER //
// ./src/cultivation/components/tree_replant/tree_replant_form.js